/* @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import { ImgSanity } from '@slite/components'
import { SearchIcon } from '@slite/icons'

import { Section } from '../../components/Section'
import { WebsiteText } from '../../components/WebsiteText'

const searchInputStyles = css`
  outline: none;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;

  &:hover,
  &:focus {
    background-color: var(--white);
    border-color: var(--shade-05);
  }
`

const HANDS_IMAGES = [
  'https://cdn.sanity.io/images/dnsgqii5/production/e1c278f00089854d3576c403451e2faa58e595d2-971x1060.png',
  'https://cdn.sanity.io/images/dnsgqii5/production/9bfc6f2309d1f471a1662b3d3a07354fabd510c6-1025x1051.png',
  'https://cdn.sanity.io/images/dnsgqii5/production/3c053ea242004b9d809297b0f77486a6699d87d0-1032x927.png',
]

export function IntegrationsHeader({
  searchValue,
  onSearchChange,
}: {
  searchValue: string
  onSearchChange: (value: string) => void
}) {
  const intl = useIntl()

  return (
    <Section
      background="moon-dust-lighter"
      className="text-align-center"
      containerBottomPadding={60}
    >
      <div className="grid-12">
        <div className="grid-span-8-large grid-offset-2-large grid-span-12 flexbox flexbox-column flexbox-align-center">
          <div className="flexbox flexbox-align-center flexbox-justify-center flexbox-gap-40 margin-bottom-32">
            <ImgSanity src={HANDS_IMAGES[0]} width={120} alt="" />
            <ImgSanity src={HANDS_IMAGES[1]} width={120} alt="" />
            <ImgSanity src={HANDS_IMAGES[2]} width={120} alt="" />
          </div>
          <WebsiteText variant="display" className="margin-bottom-16">
            <FormattedMessage
              id="integrations.page.heroTitle"
              defaultMessage="Integrations"
            />
          </WebsiteText>
          <WebsiteText
            variant="body"
            className="font-weight-semibold margin-bottom-32"
            style={{ maxWidth: 500 }}
          >
            <FormattedMessage
              id="integrations.page.heroSubtitle"
              defaultMessage="Connect your favorite tools to give the Slite agent context, call it from anywhere, or embed content directly in your docs."
            />
          </WebsiteText>
          <div
            className="position-relative width-full"
            style={{ maxWidth: 360 }}
          >
            <input
              aria-label={intl.formatMessage({
                id: 'integrations.search.ariaLabel',
                defaultMessage: 'Search integrations',
              })}
              type="text"
              placeholder={intl.formatMessage({
                id: 'integrations.search.placeholder',
                defaultMessage: 'Search integrations',
              })}
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className={classNames(
                'width-full border-small radius-largest padding-vertical-16 font-size-6',
                searchValue
                  ? 'background-white border-shade-05'
                  : 'background-transparent border-alpha-shade-40'
              )}
              css={searchInputStyles}
              style={{ paddingLeft: 20, paddingRight: 46 }}
            />
            <SearchIcon
              size={18}
              className="position-absolute shade-30"
              style={{ right: 24, top: '50%', transform: 'translateY(-50%)' }}
            />
          </div>
        </div>
      </div>
    </Section>
  )
}
